"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectFitEnum = exports.FileUsageSource = exports.isFileSource = exports.FileUsageTypeEnum = void 0;
var FileUsageTypeEnum;
(function (FileUsageTypeEnum) {
    FileUsageTypeEnum["common"] = "common";
    FileUsageTypeEnum["audio"] = "audio";
    FileUsageTypeEnum["video"] = "video";
    FileUsageTypeEnum["image"] = "image";
    FileUsageTypeEnum["embeddedArchive"] = "embeddedArchive";
    FileUsageTypeEnum["fontGroup"] = "fontGroup";
    FileUsageTypeEnum["font"] = "font";
    FileUsageTypeEnum["captions"] = "captions";
})(FileUsageTypeEnum || (exports.FileUsageTypeEnum = FileUsageTypeEnum = {}));
const isFileSource = (usage) => Boolean(usage.source === FileUsageSource.file && usage.id);
exports.isFileSource = isFileSource;
var FileUsageSource;
(function (FileUsageSource) {
    FileUsageSource["url"] = "url";
    FileUsageSource["file"] = "file";
})(FileUsageSource || (exports.FileUsageSource = FileUsageSource = {}));
var ObjectFitEnum;
(function (ObjectFitEnum) {
    ObjectFitEnum["cover"] = "cover";
    ObjectFitEnum["contain"] = "contain";
    ObjectFitEnum["fill"] = "fill";
})(ObjectFitEnum || (exports.ObjectFitEnum = ObjectFitEnum = {}));
